import { Injectable } from '@angular/core';

@Injectable()

export class WcagService {

  public wcagElement: any;
  public elementRef: any;
  public wcagText: string;
  public queueRun: boolean;

  private queueTable: any[] = [];
  private wcagFocus: any;

  constructor() {
  }

  public startQueue(wcagText: string) {
    this.queueRun = true;
    this.runQueue(wcagText);
  }

  public runQueue(wcagText: string) {
    if (!this.queueRun) {
      return;
    }

    this.queueTable.push(wcagText);

    if (!this.queueTable.length) {
      this.queueRun = false;
      return
    }
    this.wcagElement = this.queueTable.shift();

    this.queueRun = false;
    this.wcagRead(this.wcagElement);

    setTimeout(() => {
      this.runQueue(wcagText)
    }, 2000)
  }

  public wcagRead(wcagElement: string) {
    this.wcagText = wcagElement;
    setTimeout(() => {
      this.wcagFocus = this.elementRef.nativeElement.querySelector('.wcag');
      this.wcagFocus.focus();
    });
  }
}

